<script>
  import EmailSignupForm from "$lib/contentTypes/EmailSignupForm.svelte";
  import FormField from "./FormField.svelte";
  import { setContext } from "svelte";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { writable } from "svelte/store";
  import { getUserFriendlyCampaignFromName, newsletterKeys } from "$lib/utilities/formFields";
  import Heading from "../Heading.svelte";
  import Icon from "../Icon.svelte";

  export let data;
  export let result = {};
  export let preSelectedNewsletters;
  let newsletterSurround;

  let newsletterOptions = data.fields.optionsToInclude.map((x) => newsletterKeys[x]);
  /* Initialize the store to have a key representing each option and a value
    representing whether it's been selected. */
  let newsletterStore = {};
  newsletterOptions.forEach((option) => {
    newsletterStore[option.fieldProps.name] = false;
  });
  if (preSelectedNewsletters) {
    newsletterStore = preSelectedNewsletters;
  }
  let selectedNewsletters = writable(newsletterStore);

  const props = {
    data: data.fields.emailSignUpForm,
    buttonVariant: "primary",
    noCampaignErrorMessage: data.fields.errorMsgNoneSelected
  };

  function handleChange(ev) {
    const { detail } = ev;

    if (detail.name === "newsletters-select-all") {
      // Select or de-select all options.
      selectedNewsletters.update((state) => {
        Object.keys($selectedNewsletters).forEach((id) => {
          state[id] = document.getElementById("newsletters-select-all").checked;
        });
        return state;
      });
    } else {
      selectedNewsletters.update((state) => {
        // If select-all is checked and we unselect one option, also unselect select-all option.
        if (!detail.value && $selectedNewsletters["newsletters-select-all"]) {
          state["newsletters-select-all"] = detail.value;
        }

        state[detail.name] = detail.value;

        // Return true if all newsletters selected or are the select-all option.
        let allSelected = () =>
          Object.keys($selectedNewsletters).every(
            (selection) => $selectedNewsletters[selection] || selection === "newsletters-select-all"
          );

        // If all options are selected, make sure select-all is selected.
        if (detail.value && !$selectedNewsletters["newsletters-select-all"] && allSelected()) {
          state["newsletters-select-all"] = detail.value;
        }
        return state;
      });
    }
  }

  // If successfully registered, focus page at the top to display success message.
  $: if (result.status === "success") {
    newsletterSurround?.scrollIntoView({ behavior: "smooth" });
  }

  $: setContext("selectedNewsletters", selectedNewsletters);
  // The user friendly names of the campaigns are displayed in the success message
  let friendlyNamesOfCampaigns = [];
  $: friendlyNamesOfCampaigns = Object.keys($selectedNewsletters)
    .filter(
      // Filter for selected campaigns
      (newsletter) => $selectedNewsletters[newsletter] && newsletter !== "newsletters-select-all"
    )
    // Map to the user friendly names of the campaign
    .map((newsletter) => getUserFriendlyCampaignFromName(newsletter));
</script>

<div aria-live="polite" class="max-w-806 mx-auto" bind:this={newsletterSurround}>
  {#if result.status !== "success"}
    <div class="flex flex-col gap-32 md:gap-24">
      {#each newsletterOptions as field}
        <div class={`flex-row md:flex-col ${field.fieldClass} mt-40`}>
          <FormField
            fieldType={field.fieldType}
            fieldProps={{
              ...field.fieldProps,
              defaultValue: $selectedNewsletters[field.fieldProps.name]
            }}
            on:clear={field.fieldProps.handleClear}
            on:change={handleChange}
          />
        </div>
      {/each}
    </div>
    <div class="mt-40">
      <EmailSignupForm {...props} bind:result />
    </div>
  {:else}
    <div class="flex flex-col gap-32 md:gap-24 pt-48">
      <Heading text="Thanks for signing up for the following newsletters:" class="heading-3" />
      <ul class="list-none">
        {#each friendlyNamesOfCampaigns as campaign}
          <li class="flex flex-row content-center my-16">
            <Icon type="confirm" size="md" class="!inline mr-8 align-top" />
            <p>{campaign}</p>
          </li>
        {/each}
      </ul>
    </div>
  {/if}
</div>
